export default __webpack_public_path__ + "static/media/square-3.347eaa9f.svg";